import { render, staticRenderFns } from "./CaseMembers.vue?vue&type=template&id=35603400&scoped=true&lang=pug&"
import script from "./CaseMembers.vue?vue&type=script&lang=js&"
export * from "./CaseMembers.vue?vue&type=script&lang=js&"
import style0 from "./CaseMembers.vue?vue&type=style&index=0&id=35603400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35603400",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VBtn,VFlex,VLayout,VSnackbar})
